<template>
  <div class="page-text">
    <h1>{{ title }}</h1>
    <div v-html="content"></div>
  </div>
</template>

<script>
export default {
  name: "PageText",
  props: {
    title: {
      type: String,
      default: "",
    },
    content: {
      type: String,
      default: "",
    }
  },
};
</script>

<style scoped></style>
